import { component } from 'picoapp'
import $ from 'quantdom'
import { shopifyCart } from '../api/cart'
import { storefrontClient, updateDiscountCodes, getWholesalerMetaobjectById } from '../api/storefront'
import { resizeImageSrc } from '../lib/utils'

export default component(async (node) => {
  const addWholesalerCookie = (wholesaler_id) => {
    const cookie_age = $('[data-cookie-length]').attr('data-cookie-length')
    document.cookie = `wholesaler_id=${wholesaler_id}; max-age=${cookie_age}; path=/`
  }

  const getWholesalerCookie = () => {
    const cookies = document.cookie.split(';')
    let wholesaler_id = ''
    cookies.forEach((cookie) => {
      if (cookie.includes('wholesaler_id')) {
        wholesaler_id = cookie.split('=')[1]
      }
    })
    if (wholesaler_id == 'null') {
      return null
    }
    return wholesaler_id
  }

  const showBanner = () => {
    $(node).attr('aria-hidden', 'false')
    $('#alertBanner').attr('aria-hidden', 'true')
  }

  const updateSideCartBanner = () => {
    // get #side-cart shadowroot
    const sideCart = document.querySelector('#side-cart')
    const sideCartHeader = sideCart.querySelector('cart-drawer').shadowRoot.querySelector('.cart-drawer_header')
    const sideCartBanner = sideCart
      .querySelector('cart-drawer')
      .shadowRoot.querySelector('.gift-with-purchase_one-time-header')

    if (sideCartBanner) {
      sideCartBanner.innerHTML = `${$('[data-wholesaler-sidecart-banner]').attr('data-wholesaler-sidecart-banner')}`
    } else {
      sideCartHeader.appendChild(document.createElement('div')).innerHTML = `You're shopping ${$(
        '[data-wholesaler-name]'
      ).text()}'s dispensary`
      sideCartHeader.lastChild.classList.add('gift-with-purchase_one-time-header')
    }
  }

  const updateDataAttributes = (id, name, image) => {
    $('[data-wholesaler-id]').attr('data-wholesaler-id', id)
    $('[data-wholesaler-name]').text(name)
    if (image) {
      $('[data-wholesaler-image]').attr('src', resizeImageSrc(image, 100))
    } else {
      $('[data-wholesaler-image]').attr('src', resizeImageSrc(`${assets}_icon-needed-n.svg`, 100))
    }

    localStorage.setItem('wholesaler', JSON.stringify({ id, name, image }))
  }

  const updateWholesalerDiscountCode = async (client, cartToken, code) => {
    console.debug('discount code', code)
    $('[data-wholesaler-code]').attr('data-wholesaler-code', code)
    const discountCodes = code ? [code] : []
    console.debug('update discount to', discountCodes)
    await updateDiscountCodes(client, cartToken, discountCodes)
    window.MicroBus.emit('cart:refresh')
  }

  const updateCartAttributes = async (client, cartToken, id, name, image) => {
    await shopifyCart.addAttribute({ wholesaler_id: id, wholesaler_name: name, wholesaler_image: image })
    if (id) {
      await updateWholesalerDiscountCode(client, cartToken, $('[data-wholesaler-code]').attr('data-wholesaler-code'))
    } else if (cart.cart_level_discount_applications.length > 0) {
      await updateWholesalerDiscountCode(client, cartToken, null)
    }
  }

  const setupWholesalerData = async (client, token, id) => {
    console.debug('id', id)
    console.debug('token', token)
    const { data } = await getWholesalerMetaobjectById(client, id)

    const mappedData = {
      impact_id: data.metaobject.impact_id.value,
      practitioner: {
        name: data.metaobject.practitioner.reference.name.value,
        image:
          data.metaobject.practitioner.reference.image.reference.image.url ||
          resizeImageSrc(`${assets}_icon-needed-n.svg`, 100),
      },
    }
    updateDataAttributes(mappedData.impact_id, mappedData.practitioner.name, mappedData.practitioner.image)
    await updateCartAttributes(
      client,
      token,
      mappedData.impact_id,
      mappedData.practitioner.name,
      mappedData.practitioner.image
    )
  }

  const wholesaler_id = $(node).attr('data-wholesaler-id')
  const urlParams = new URLSearchParams(window.location.search)
  const utmAffilitate = urlParams.get('irpid')
  const currentWholesalerCookie = getWholesalerCookie()
  const url = new URL(window.location)
  const assets = url.host === '127.0.0.1:9292' ? `${url.origin}/assets/` : window.Needed_Store.asset_url
  const client = storefrontClient
  const cart = await shopifyCart.fetchCart()
  console.debug('cart before', cart)
  const token = cart.token

  const init = async () => {
    console.log('init')
    if (!currentWholesalerCookie && !utmAffilitate) {
      console.debug('A - no cookie, no wholesaler param')
      console.debug('clear cart attributes')
      await updateCartAttributes(client, token, null, null, null)
      console.debug('A')
    } else if (wholesaler_id == utmAffilitate) {
      console.debug('B - cart attribute matches param')
      console.debug('set wholesaler cookie')
      addWholesalerCookie(utmAffilitate)
      console.debug('show banner')
      showBanner()
      updateSideCartBanner()
      console.debug('B')
    } else if (
      (wholesaler_id && utmAffilitate && wholesaler_id != utmAffilitate) ||
      (!wholesaler_id && !currentWholesalerCookie && utmAffilitate)
    ) {
      console.debug('C - cart attribute and param present, dont match OR no cart attribute, no cookie, and param present')
      console.debug('set wholesaler cookie')
      addWholesalerCookie(utmAffilitate)
      console.debug('sync wholesaler data to HTML and cart')
      await setupWholesalerData(client, token, utmAffilitate)
      console.debug('show banner')
      showBanner()
      updateSideCartBanner()
      console.debug('C')
    } else if (
      (currentWholesalerCookie && !utmAffilitate) ||
      (currentWholesalerCookie && utmAffilitate && currentWholesalerCookie == utmAffilitate)
    ) {
      console.debug('D = has cookie, no param present OR cookie matches param')
      await setupWholesalerData(client, token, currentWholesalerCookie)
      showBanner()
      updateSideCartBanner()
      console.debug('D')
    } else {
      console.debug('E base case')
      console.debug('clear cart attributes')
      await updateCartAttributes(client, token, null, null, null)
      console.debug('E')
    }
  }

  await init()
  const afterCart = await shopifyCart.fetchCart()
  console.debug('cart after', afterCart)
})
